<h3 class="ui primary header">
  Fund eWallet
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div *ngIf="success || error" appMargin marginY="10px">
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
</div>

<div class="content">
  <div class="ui basic vertical segment">
    <div class="ui form">
      <label class="amount-info"
        ><span>Amount to Fund</span>
        <span class="min-amount-text">
          (Minimum amount to fund is
          {{ modal.context.account?.currencyCode
          }}{{ modal.context.account?.minFundingAmount | number: ".2-2" }})
        </span></label
      >
      <!-- <div class="ui fluid input" style="padding-top: 10px">
        <input
          type="number"
          placeholder="Enter the amount you want to fund"
          [(ngModel)]="amount"
        />
      </div> -->
      <div [formGroup]="fundWalletForm">
        <app-currencyfmt-number-input
          [currencySymbol]="modal.context.account?.currencyCode"
          [placeholder]="'Enter the amount you want to fund'"
          formControlName="amount"
        ></app-currencyfmt-number-input>
      </div>
    </div>
  </div>

  <div class="actions" style="background: transparent; border: none">
    <button class="ui basic primary button" (click)="modal.deny(undefined)">
      Back
    </button>
    <button
      class="ui primary button"
      [ngClass]="{ loading: pending }"
      (click)="submit()"
      autofocus
      [disabled]="
        !fundWalletForm.value.amount ||
        fundWalletForm.value.amount < modal.context.account.minFundingAmount
      "
    >
      Proceed
    </button>
  </div>
</div>
